export { ErrorBoundary, default } from "./routes/professional_article/main.tsx";